import BereavmentIcon from "@/assets/svgs/faq/BereavmentIcon";
import CollectionIcon from "@/assets/svgs/faq/CollectionIcon";
import DocumentsIcon from "@/assets/svgs/faq/DocumentsIcon";
import FaceIcon from "@/assets/svgs/faq/FaceIcon";
import PaymentIcon from "@/assets/svgs/faq/PaymentIcon";
import SellingIcon from "@/assets/svgs/faq/SellingIcon";
import TrackerIcon from "@/assets/svgs/faq/TrackerIcon";
import ValuationIcon from "@/assets/svgs/faq/ValuationIcon";

// icons for FAQcategory
import BereavmentCategoryIcon from "@/assets/svgs/faqCategory/BereavmentCategoryIcon.svg";
import BereavmentCategoryActive from "@/assets/svgs/faqCategory/BereavmentCategoryActive.svg";
import CarValueTrackerCategory from "@/assets/svgs/faqCategory/CarValueTrackerCategory.svg";
import CarValueTrackerCategoryActive from "@/assets/svgs/faqCategory/CarValueTrackerActive.svg";
import CollectionIconCategory from "@/assets/svgs/faqCategory/CollectionIconCategory.svg";
import CollectionIconCategoryActive from "@/assets/svgs/faqCategory/CollectionIconCategoryActive.svg";
import DocumentsIconCategory from "@/assets/svgs/faqCategory/DocumentsIconCategory.svg";
import DocumentsIconCategoryActive from "@/assets/svgs/faqCategory/DocumentsIconCategoryActive.svg";
import PaymentIconCategory from "@/assets/svgs/faqCategory/PaymentCategory.svg";
import PaymentIconCategoryActive from "@/assets/svgs/faqCategory/PaymentIconCategoryActive.svg";
import ProfilingIconCategory from "@/assets/svgs/faqCategory/ProfilingIconCategory.svg";
import ProfilingIconCategoryActive from "@/assets/svgs/faqCategory/ProfilingIconCategoryActive.svg";
import SellingIconCategory from "@/assets/svgs/faqCategory/SellingIconCategory.svg";
import SellingIconCategoryActive from "@/assets/svgs/faqCategory/SellingIconCategoryActive.svg";
// Fragen und antworten

import {
  ueberAutoeinfachlos,
  verkaufenMitAutoeinfachlos,
  bewertung,
  fahrzeugInformationUndFahrzeugprofil,
  dokumente,
  abholung,
  bezahlung,
  fahrzeugueberwachungsTool,
} from "./FragenUndAntowrten";

export const topicsData = [
  {
    id: 1,
    title: "Über Autoeinfachlos",
    description: "Wie es funktioniert, was unser Service ist und mehr.",
    link: "/ueber-autoeinfachlos",
    icon: BereavmentIcon,
    collectionIcon: BereavmentCategoryIcon,
    collectionIconActive: BereavmentCategoryActive,
    subpages: ueberAutoeinfachlos,
    metaTitle: "Über Autoeinfachlos – Häufige Fragen | Autoeinfachlos",
    metaDescription:
      "Was ist Autoeinfachlos und wie funktioniert es? Erfahre, warum unsere Plattform sicher und unkompliziert ist, um dein Auto zu verkaufen – einfach erklärt im Autoeinfachlos Hilfezentrum!",
  },
  {
    id: 2,
    title: "Verkaufen mit Autoeinfachlos",
    description:
      "Wie es funktioniert, welche Fahrzeuge du verkaufen kannst und mehr.",
    link: "/verkaufen-mit-autoeinfachlos",
    icon: SellingIcon,
    collectionIcon: SellingIconCategory,
    collectionIconActive: SellingIconCategoryActive,
    subpages: verkaufenMitAutoeinfachlos,
    metaTitle: "Verkaufen mit Autoeinfachlos – Häufige Fragen | Autoeinfachlos",
    metaDescription:
      "Alles über den Verkauf mit Autoeinfachlos: Höchstes Angebot, Gebühren, Fahrzeugtypen und mehr. Erfahre, wie einfach und flexibel der Autoverkauf ist – im Autoeinfachlos Hilfezentrum!",
  },
  {
    id: 3,
    title: "Bewertung",
    description: "Dein geschätzter Verkaufspreis und wie wir ihn berechnen.",
    link: "/bewertung",
    icon: ValuationIcon,
    collectionIcon: CollectionIconCategory,
    collectionIconActive: CollectionIconCategoryActive,
    subpages: bewertung,
    metaTitle: "Auto Bewerten – Häufige Fragen & Antworten | Autoeinfachlos",
    metaDescription:
      "Finde Antworten zu deinen Fragen rund um die Autobewertung mit Autoeinfachlos: Mindestpreis, geschätzter Verkaufspreis, Einflussfaktoren und mehr. Alles, was du wissen musst – klar und einfach erklärt!",
  },
  {
    id: 4,
    title: "Fahrzeuginformationen und Fahrzeugprofil",
    description:
      "Die Informationen, die wir über dein Fahrzeug und Fotos benötigen.",
    link: "/fahrzeugprofil",
    icon: FaceIcon,
    collectionIcon: ProfilingIconCategory,
    collectionIconActive: ProfilingIconCategoryActive,
    subpages: fahrzeugInformationUndFahrzeugprofil,
    metaTitle:
      "Fahrzeuginformationen & Fahrzeugprofil – Häufige Fragen | Autoeinfachlos",
    metaDescription:
      "Alles rund um dein Fahrzeugprofil: Infos zu Fotos, Gebrauchsspuren, Servicehistorie und mehr. Erfahre, wie du dein Auto optimal für den Verkauf präsentierst und loslegst!",
  },
  {
    id: 5,
    title: "Dokumente",
    description: "Die benötigten Dokumente und wo du sie finden kannst.",
    link: "/dokumente",
    icon: DocumentsIcon,
    collectionIcon: DocumentsIconCategory,
    collectionIconActive: DocumentsIconCategoryActive,
    subpages: dokumente,
    metaTitle:
      "Dokumente für den Autoverkauf – Häufige Fragen | Autoeinfachlos",
    metaDescription:
      "Welche Dokumente brauchst du für den Verkauf? Alles über Kaufverträge, finanziertes Auto verkaufen, Sicherheit deiner Daten und mehr. Finde alle Antworten bei Autoeinfachlos im Hilfezentrum!",
  },
  {
    id: 6,
    title: "Abholung",
    description: "Der Abholprozess und wie er funktioniert.",
    link: "/abholung",
    icon: CollectionIcon,
    collectionIcon: PaymentIconCategory,
    collectionIconActive: PaymentIconCategoryActive,
    subpages: abholung,
    metaTitle: "Abholung deines Fahrzeugs – Häufige Fragen | Autoeinfachlos",
    metaDescription:
      "Alles zur Abholung deines Autos: Ablauf, Zeitplan, notwendige Dokumente und mehr. Erfahre, wer dein Fahrzeug abholt und was am Verkaufstag wichtig ist – einfach erklärt bei Autoeinfachlos im Hilfezentrum!",
  },
  {
    id: 7,
    title: "Bezahlung",
    description: "Alle Antworten auf deine Fragen zur Bezahlung.",
    link: "/bezahlung",
    icon: PaymentIcon,
    collectionIcon: CollectionIconCategory,
    collectionIconActive: CollectionIconCategoryActive,
    subpages: bezahlung,
    metaTitle: "Bezahlung beim Autoverkauf – Häufige Fragen | Autoeinfachlos",
    metaDescription:
      "Alles zur Bezahlung deines Fahrzeugs: Zahlungszeitpunkt, Abwicklung von Finanzierungen und Garantien. Erfahre, wie und wann du dein Geld erhältst – einfach erklärt im Autoeinfachlos Hilfezentrum!",
  },
  {
    id: 8,
    title: "Fahrzeugwert-Überwachungstool",
    description:
      "Alles, was du über die Verfolgung des Werts deines Fahrzeugs wissen musst.",
    link: "/fahrzeugwert-ueberwachungstool",
    icon: TrackerIcon,
    collectionIcon: CarValueTrackerCategory,
    collectionIconActive: CarValueTrackerCategoryActive,
    subpages: fahrzeugueberwachungsTool,
    metaTitle:
      "Fahrzeugwert-Überwachungstool – Häufige Fragen | Autoeinfachlos",
    metaDescription:
      "Erfahre alles über das Fahrzeugwert-Überwachungstool: Benachrichtigungen verwalten, Datenquellen, Fahrzeugtypen und mehr. Bleib immer über den Wert deines Autos informiert – einfach erklärt im Autoeinfachlos Hilfezentrum!",
  },
];
